import { render, staticRenderFns } from "./WebTwoNoticeNeedRead.vue?vue&type=template&id=4a4bb565&scoped=true&"
import script from "./WebTwoNoticeNeedRead.vue?vue&type=script&lang=js&"
export * from "./WebTwoNoticeNeedRead.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoNoticeNeedRead.vue?vue&type=style&index=0&id=4a4bb565&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bb565",
  null
  
)

export default component.exports